import { render } from "./LargeCoupon.vue?vue&type=template&id=65dd1a53&scoped=true"
import script from "./LargeCoupon.vue?vue&type=script&lang=js"
export * from "./LargeCoupon.vue?vue&type=script&lang=js"

import "./LargeCoupon.vue?vue&type=style&index=0&id=65dd1a53&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-65dd1a53"

export default script